module.exports = __webpack_public_path__ + "img/NL.5f6ef944.svg";